<template>
  <v-card flat>
    <v-card-title>Tågsammansättning</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            :items="items"
            :value-comparator="valueComparator"
            item-value="data"
            item-text="_text"
            outlined
            label="Tågsammansättningar"
            v-model="model.traincompositions"
            item-disabled="hidden"
            multiple
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click:close="remove(data.item)"
              >
                {{ data.item._text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <template v-if="searchParameters">
        <template v-for="(traincomposition, $i) in model.traincompositions">
          <v-container :key="$i">
            <v-row>
              <v-col>
                {{ getDescription(traincomposition.code) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-for="param in traincomposition.parameters"
                :key="param.name"
              >
                <template v-if="getParam(param.name).autocompleteList.length">
                  <v-autocomplete
                    :items="getParam(param.name).autocompleteList"
                    v-model="param.value"
                    :placeholder="'Välj ' + param.name"
                    :hint="getParam(param.name).description"
                    :rules="[
                      required,
                      v =>
                        !!new RegExp(getParam(param.name).regex).test(v) ||
                        'Ogiltig'
                    ]"
                    outlined
                    :label="param.name"
                  />
                </template>
                <v-text-field
                  v-else
                  :label="param.name"
                  outlined
                  v-model="param.value"
                  :hint="getParam(param.name).description"
                  :rules="[
                    required,
                    v =>
                      !!new RegExp(getParam(param.name).regex).test(v) ||
                      'Ogiltig'
                  ]"
                />
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-container>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from '@/common/validationRules'
import SEARCH_PARAMETERS from '../../graphql/searchParameters'
import { get } from 'vuex-pathify'

export default {
  name: 'DuwaTrainCompositions',

  props: {
    codes: {
      type: Array,
      default: () => []
    }
  },

  apollo: {
    searchParameters: {
      query: SEARCH_PARAMETERS,
      fetchPolicy: 'no-cache'
    }
  },

  data: () => ({
    required,
    model: {
      traincompositions: []
    }
  }),

  created() {
    this.model.traincompositions = this.currentTrainCompositions.slice()
  },

  watch: {
    'model.traincompositions'(value) {
      this.$store.set(
        'duwa/payload',
        this.payload.map(x => ({
          ...x,
          traincomposition: {
            ...x.traincomposition,
            after: value
          }
        }))
      )
    }
  },

  computed: {
    payload: get('duwa/payload'),
    currentTrainCompositions: get('duwa/currentTrainCompositions'),
    items() {
      return this.codes
        .filter(x => x.category === 'traincomposition')
        .map(x => {
          if (x.text_43_characters) {
            x._text = x.text_43_characters
          } else if (x.text_13_characters) {
            x._text = x.text_13_characters
          } else if (x.text_9_characters) {
            x._text = x.text_9_characters
          }
          x.data = {
            parameters: (x.parameters || []).map(({ name, value }) => ({
              name,
              value
            })),
            code: x.code
          }
          return x
        })
        .filter(
          x =>
            !x.hidden ||
            this.currentTrainCompositions.some(({ code }) => code === x.code)
        )
    },

    arrivalPlaces: get('trainDeviation/arrivalPlaces'),

    places() {
      return this.model.type === 'RST' && this.arrivalPlaces.length
        ? this.arrivalPlaces
        : this.stops
    }
  },

  methods: {
    getParam(attribute) {
      return (this.searchParameters || []).find(
        x => x.attribute === attribute.toLowerCase()
      )
    },

    valueComparator(a, b) {
      if (!a || !b) return false
      const transformB = Array.isArray(b) ? b : [b]
      return transformB.some(x => x.code === a.code)
    },
    getDescription(code) {
      return this.items.find(x => x.code === code)._text
    },

    isDisabled(code) {
      return this.items.find(x => x.code === code).hidden
    },

    remove(item) {
      const index = this.model.traincompositions.findIndex(
        x => x.code === item.code
      )
      if (index >= 0) this.model.traincompositions.splice(index, 1)
    }
  }
}
</script>
